{
  "version": 1,
  "asset_id": "baee8a04-c991-41cd-a66c-36bf7514b2f2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/baee8a04-c991-41cd-a66c-36bf7514b2f2/bypass-normal-boxed-en-796.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/baee8a04-c991-41cd-a66c-36bf7514b2f2/bypass-normal-boxed-en-796.jpg",
  "original_filename": "bypass-normal-boxed-en-796.jpg",
  "size": 57040,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:08:58Z"
}
